var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('section',{staticClass:"fk-contents"},[_c('p',{staticClass:"text-error"},[_vm._v(_vm._s(_vm.text.OrderFailed))]),_vm._v(" "),_c('p',{staticClass:"mod-form-btn"},[_c('input',{staticClass:"btn-base btn-negative btn-quit",attrs:{"type":"button","value":_vm.text.Return},on:{"click":_vm.execReturn}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d1bd8b4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OrderFailed.vue
// module id = null
// module chunks = 